module.exports = __webpack_public_path__ + "img/e4712b43-1b40-4667-a02f-20041a238c1f.012.14fe3ee9.png";